import { mesh2ndRect } from "./mesh2ndRect";
import { mesh3rdRect } from "./mesh3rdRect";
import { mesh4thRect } from "./mesh4thRect";

// let filecheck = 5;
let flyto = true;

export const csvfecthforcheck = (
  rfcs,
  dataname,
  no,
  year,
  area,
  csv_name,
  year1_nihonsokuchi,
  metadata,
  ratio1set,
  alpha1set,
  color1set,
  shikii1set
) => {
  // console.log(`/csv/${metadata.no}/${area}_${csv_name}_${year}.csv`);

  // console.log(area);
  let areaarr = area.includes("&") ? area.split("&") : [area];
  const areafilename = areaarr.map((areai) => {
    // console.log(areai);
    return `/csv/${metadata.no}/${areai}_${csv_name}_${year}.csv`;
  });
  // console.log(areafilename);

  // const fetchPromises = areafilename.map((filenameaa) => {
  //   return fetch(filenameaa)
  //     .then((r) => {
  //       if (!r.ok) {
  //         throw new Error();
  //       }
  //       return r;
  //     })
  //     .then((response) => response.text());
  // });

  // fetch( `/csv/${metadata.no}/${area}_${csv_name}_${year}.csv` , {})
  fetch(areafilename[0], {
    headers: { Range: "bytes=0-1023" },
  })
    .then((r) => {
      if (!r.ok) {
        throw new Error();
      }
      return r.text();
    })
    .then((r) => {
      if (r.startsWith("<")) {
        throw new Error();
      }
      // if(r.startsWith("<")){ filecheck = filecheck + 1 }
      return r;
    })
    .catch(() => {
      // console.log("ファイルなし");
      setTimeout(() => {
        window.alert(
          "この地域にはデータがありません。市町村名を確認してください。"
        );
      }, 3000);
    });
};
